import React from "react";

import { Icon, Image } from "semantic-ui-react"
import { AppColumn, AppRow } from "./Layouts"
import AppText from "../UI/Texts/AppTexts"
import useTheme from "../../hooks/useTheme";

import useAssets from "../../hooks/useAssets"
import { useResponsive } from "./ResponsiveContext"
import { SizedBox } from "./Sizes"


export const WorkplaceCard = ({ workplaceData, insightsAssessment, width }) => {
    const { isMobile } = useResponsive();
    const theme = useTheme();
    const { aidKit } = useAssets();
    // const imageSize = isMobile ? "18vw" : "60px";

    return (<AppRow crossAxisAlignment={'center'} mainAxisAlignment={'space-between'}>
        {/* <Image
            src={workplaceData.logoUrl.length === 0 ? aidKit : workplaceData.logoUrl}
            bordered
            style={{
                borderRadius: isMobile ? APP_BORDER_RADIUS_SMALL : APP_BORDER_RADIUS,
                width: imageSize,
                height: imageSize,
                objectFit: "cover",
                padding: theme.spacing.elementPaddingSmall,
                marginTop: isMobile && theme.spacing.elementPaddingSmall,
                marginRight: theme.spacing.elementPadding,
                backgroundColor: "#D3D3D3",
            }}
        /> */}

        <AppColumn mainAxisAlignment="start"
            style={{
                width: isMobile ? '100%' : width ? width * 0.8 : '100%',
                flex: 2,
            }}
        >
            <AppText.BodyText fontWeight={600} margins={{ marginBottom: "0px" }} >
                {workplaceData["name"]}
            </AppText.BodyText>

            {(workplaceData?.nameVerksamhet && workplaceData.nameVerksamhet.length > 0) && <AppText.BodyText margins={{ marginBottom: "0px" }}>
                {workplaceData["nameVerksamhet"] ?? ""}
            </AppText.BodyText>}
        </AppColumn>

        {(insightsAssessment && insightsAssessment.score > 0) && <AppRow crossAxisAlignment={'center'} >
            <SizedBox width={theme.spacing.contentElementPadding} />
            <Icon
                name="star"
                circular
                style={{
                    color: theme.primaryColor

                }} />
            <SizedBox width={theme.spacing.elementPaddingSmall} />
            <AppText.Caption>   {parseFloat(`${insightsAssessment.score}`).toPrecision(2)}</AppText.Caption>
        </AppRow>}
    </AppRow>)
}


export const WorkplaceCardSmall = ({ workplaceData }) => {
    const { isMobile } = useResponsive();
    const theme = useTheme();
    const { aidKit } = useAssets();
    const imageSize = isMobile ? "18vw" : "60px";

    const hasImage = workplaceData.logoUrl.length > 0;

    return (<AppRow crossAxisAlignment={isMobile ? "Start" : "center"}>
        <Image
            src={!hasImage ? aidKit : workplaceData.logoUrl}
            bordered
            loading='lazy'
            style={{
                borderRadius: "0.5rem",
                width: imageSize,
                height: imageSize,
                objectFit: "cover",
                padding: !hasImage && theme.spacing.elementPaddingSmall,
                marginTop: isMobile && theme.spacing.elementPaddingSmall,
                marginRight: theme.spacing.elementPadding,
                backgroundColor: "#FFFFFF",
            }}
        />
        <AppColumn mainAxisAlignment="start" >
            <AppText.Caption fontWeight={600} margins={{ marginBottom: "0px" }} >
                {workplaceData["name"]}
            </AppText.Caption>
            <AppText.Caption margins={{ marginBottom: "0px" }}>
                {workplaceData["orgName"]}
            </AppText.Caption>
            <AppText.Caption margins={{ marginBottom: "0px" }}>
                {workplaceData["nameVerksamhet"] ?? ""}
            </AppText.Caption>
        </AppColumn>
    </AppRow>)
}